import MemberText from 'modals/AIChatModal/components/ChatMembers/components/MemberText'
import styled, { css } from 'styled-components'
import IconButton from 'share-ui/components/IconButton/IconButton'
import { Nullable } from 'types'
import { StyledDeleteIcon } from 'styles/styledIcons.css'

type ListCardProps = {
    onClick: () => void
    onViewClick?: () => void
    onEditClick?: () => void
    onDeleteClick?: () => void
    picked?: boolean
    name: string
    logo?: string
    status?: Nullable<string>
    error?: Nullable<string>
    icon?: React.ReactElement
}

const ListCard = ({ picked = false, onClick, logo, name, onDeleteClick, icon }: ListCardProps) => {
    const handleDelete = (event: any) => {
        event.stopPropagation()
        if (onDeleteClick) {
            onDeleteClick()
        }
    }

    return (
        <StyledRoot onClick={onClick} picked={picked}>
            {logo && <StyledImg src={logo} />}
            {icon}

            <MemberText name={name} />

            <StyledIconButtonWrapper className='hiddenButton'>
                {onDeleteClick && (
                    <IconButton
                        onClick={handleDelete}
                        icon={() => <StyledDeleteIcon />}
                        size={IconButton.sizes?.SMALL}
                        kind={IconButton.kinds?.TERTIARY}
                        ariaLabel='Delete'
                    />
                )}
            </StyledIconButtonWrapper>
        </StyledRoot>
    )
}

export default ListCard

const StyledRoot = styled.div<{ picked?: boolean }>`
    cursor: pointer;

    max-width: 260px;
    width: 100%;

    border-radius: 4px;

    display: flex;
    padding: 2px;
    padding-left: 8px;
    align-items: center;
    gap: 8px;
    align-self: stretch;

    min-height: 35px;

    :hover {
        background: rgba(0, 0, 0, 0.1);
        .hiddenButton {
            opacity: 1;
        }
    }

    ${props =>
        props.picked &&
        css`
            background: ${({ theme }) => theme.body.teamChatCardSelectedColor};
            :hover {
                background: ${({ theme }) => theme.body.teamChatCardSelectedColor};
            }
        `}

    font-weight: 500
`

const StyledImg = styled.img`
    width: 22px;
    height: 22px;

    border-radius: 8px;
`
const StyledStatus = styled.div`
    display: flex;
    align-items: center;
    gap: 4px;

    padding: 0 2px;
`
const StyledIconButtonWrapper = styled.div`
    margin-left: auto;

    opacity: 0;
    /* transition: opacity 300ms; */

    display: flex;
    align-items: center;
`
